export default "__VITE_ASSET__Cs6osCr3__"